import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BsPencilSquare, BsTrash3Fill } from "react-icons/bs";
import axios from "axios";
import LoadingOverlay from "../components/LoadingOverlay"; // Importa el nuevo componente
import $ from "jquery";

const Baner = () => {
  const navigate = useNavigate();
  const [baners, setBaners] = useState([]);
  const [loading, setLoading] = useState(true);

  const getBaners = async () => {
    try {
      const response = await axios.get(`${window.BACKEND_URL}baner`, {
        headers: {
          Authorization: `${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
          "X-Rol": `${sessionStorage.getItem("role")}`, // Corrección aquí
        },
      });
      setBaners(response.data);
    } catch (error) {
      console.error("Error al obtener los baners:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getBaners();
        //initializeDataTable();
      } catch (error) {
        console.error("Error al obtener los baners:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const initializeDataTable = async () => {
      if (!tablabaner.current || $.fn.DataTable.isDataTable(tablabaner.current))
        return;

      $(tablabaner.current).DataTable({
        language: {
          url: "//cdn.datatables.net/plug-ins/1.10.25/i18n/Spanish.json",
        },
      });
    };

    initializeDataTable();
  }, [loading]);

  const tablabaner = useRef(null);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${window.BACKEND_URL}baner/${id}`, {
        headers: {
          Authorization: `${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
          "X-Rol": `${sessionStorage.getItem("role")}`,
        },
      });

      setBaners((prevBaners) => prevBaners.filter((baner) => baner._id !== id));
    } catch (error) {
      console.error("Error al eliminar el baner:", error);
    }
  };

  const Editbaner = (banerid) => {
    navigate(`/Editbaner/${banerid}`);
  };

  return (
    <div className="position-relative">
      {loading && <LoadingOverlay loading={loading} text="Cargando..." />}
      {!loading && (
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <span className="float-end">
                  <Link to="/Addbaner" className="btn btn-primary">
                    <i className="fa-solid fa-plus"></i> Agregar Baner
                  </Link>
                </span>
                <h5 className="card-title mb-0">Baner</h5>
              </div>
              <hr />

              <div className="card-body">
                <table className="table table-bordered" ref={tablabaner}>
                  <thead>
                    <tr>
                      <th>Foto</th>
                      <th>Descripción</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {baners.map((baner) => (
                      <tr key={baner._id}>
                        <td>
                          <img
                            src={`${window.BACKEND_URL}uploads/${baner.photo}`}
                            className="w-100"
                            alt="Foto del baner"
                          />
                        </td>
                        <td>{baner.descripcion}</td>
                        <td>
                          <button
                            className="btn btn-primary me-2"
                            onClick={() => Editbaner(baner._id)}
                          >
                            <BsPencilSquare /> Editar
                          </button>
                          <button
                            onClick={() => handleDelete(baner._id)}
                            className="btn btn-danger"
                          >
                            <BsTrash3Fill /> Eliminar
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Baner;
